import React, { useEffect, useState } from 'react';
import {
  Box,
  Paper,
  Typography,
  Stack,
  Divider,
  Chip,
  CircularProgress,
} from '@mui/material';

import {useGetDatiProgByCodProg, useGetDatiProgDTO} from '../gestdatiprog/Services';

interface Props {
  codprogprop: string;
}

interface InfoItemProps {
  label: string;
  value?: React.ReactNode;
}

const InfoItem: React.FC<InfoItemProps> = ({
  label,
  value,
}) => (
  <Box sx={{ minWidth: 140 }}>

    <Typography
      variant="caption"
      color="text.secondary"
      sx={{
        fontWeight: 500,
        fontSize: '0.62rem',
        textTransform: 'uppercase',
        lineHeight: 1,
        display: 'block',
        mb: 0.3,
      }}
    >
      {label}
    </Typography>

    <Typography
      variant="body2"
      sx={{
        fontWeight: 500,
        fontSize: '0.82rem',
        lineHeight: 1.2,
      }}
    >
      {value || '-'}
    </Typography>

  </Box>
);

const ListaMonitorProgettiDatiProgInline: React.FC<Props> = ({
  codprogprop,
}) => {


const {
  data: DatiProgDTO,
  isLoading: isLoadingDatiProg,
} = useGetDatiProgDTO(
  {
    pageIndex: 0,
    pageSize: 1,
  },
  [
    {
      id: 'CODPROG',
      value: codprogprop,
    },
  ],
  '',
  []
);

  const formatDate = (
    value?: string | Date | null
  ) => {
    if (!value) return '-';

    const d = new Date(value);

    return new Intl.DateTimeFormat('it-IT', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    }).format(d);
  };

  if (isLoadingDatiProg) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          py: 3,
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

 const prog = DatiProgDTO?.results?.[0];

  if (!prog) {
    return null;
  }

return (
   <Paper
  elevation={1}
  sx={{
  width: 1340,
    p: 1.5,
    mb: 1,
    backgroundColor: 'white',
    border: '1px solid #dcdcdc',
  }}
>

  {/* ROW 1 */}
  <Stack
    direction="row"
    spacing={1}
    useFlexGap
    sx={{ mb: 1 }}
  >

    <InfoItem
      label="Data Agg.Prog."
      value={formatDate(prog.dataagg)}
    />

    {/*<InfoItem*/}
    {/*  */}
    {/*  label="Progetto"*/}
    {/*  value={prog.desprog}*/}
    {/*/>*/}

    <InfoItem
      
      label="Perc.Comp"
      value={prog.percomp}
    />

    <InfoItem

      label="Data Perc.Comp."
      value={formatDate(prog.datapercomp)}
    />


    <InfoItem
      
      label="Ref Interno"
      value={prog.ref}
    />

    <InfoItem
      
      label="Ref.Cliente"
      value={prog.refcli}
    />

  </Stack>

  {/* ROW 3 */}
  <Stack
    direction="row"
    spacing={1}
    useFlexGap
    sx={{ mb: 1 }}
  >

    <InfoItem
      
      label="Tipo Prog"
      value={prog.tipoprog}
    />

    <InfoItem
      
      label="Tipo Mig"
      value={prog.tipomig}
    />

    <InfoItem
      
      label="Tipo Inst"
      value={prog.tipoinst}
    />


    <InfoItem
      
      label="Comp.Prog."
      value={prog.compprog}
    />

    <InfoItem
      
      label="Flg DMS"
      value={prog.flgdms}
    />

    <InfoItem
      
      label="Cod Prog DMS"
      value={prog.codprogdms}
    />

  </Stack>

  {/* ROW 5 */}
  <Stack
    direction="row"
    spacing={1}
    useFlexGap
    sx={{ mb: 1 }}
  >

    <InfoItem
      
      label="Data Kickoff Firma"
      value={formatDate(prog.datafirmakickoff)}
    />

    <InfoItem
      
      label="Data Kickoff Pian."
      value={formatDate(prog.datakickoffpian)}
    />

    <InfoItem
      
      label="Data Kickoff Eff."
      value={formatDate(prog.datakickoffeff)}
    />


    <InfoItem
      label="Data Gantt"
      value={formatDate(prog.datagantt)}
    />

    <InfoItem
      label="Data GoLive Pian."
      value={formatDate(prog.datagolivepian)}
    />

    <InfoItem
      label="Data GoLive Eff."
      value={formatDate(prog.datagoliveeff)}
    />

  </Stack>

  {/* ROW 7 */}
  <Stack
    direction="row"
    spacing={1}
    useFlexGap
    sx={{ mb: 1 }}
  >

    <InfoItem
      label="Data Sal 1"
      value={formatDate(prog.data1sal)}
    />

    <InfoItem
      label="Data Sal 2"
      value={formatDate(prog.data2sal)}
    />

    <InfoItem
      
      label="Data Sal 3"
      value={formatDate(prog.data3sal)}
    />

    <InfoItem
      
      label="Data Sal 4"
      value={formatDate(prog.data4sal)}
    />

    <InfoItem
      
      label="Data Sal 5"
      value={formatDate(prog.data5sal)}
    />

    <InfoItem
      
      label="Data Coll."
      value={formatDate(prog.datacoll)}
    />

  </Stack>

  {/* NOTE */}
  <Stack
    direction="row"
    spacing={1}
    useFlexGap
  >

    <InfoItem
      
      label="Note"
      value={prog.note}
    />

  </Stack>

</Paper>
);
};

export default ListaMonitorProgettiDatiProgInline;